
export default [
    {
        path: '/comissao',
        component: () => import(/* webpackChunkName: "comissao-chunk" */ './ComissaoPage.vue')
    }
]